import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { DossierTerminationForDriver } from "../../types/Dossier";

export const getDossierTermination = (
  dossierId: string,
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();
  const { isQueryEnabled } = useAPQuery();

  return useQuery({
    queryKey: ["dossierTermination", dossierId],
    queryFn: (): Promise<DossierTerminationForDriver> => {
      return fetchWithAuth<DossierTerminationForDriver>(
        "getDossierTermination",
        dossierId
      );
    },
    enabled: isQueryEnabled(options),
  });
};
